export default {
  guide: {
    start: 'Starten',
    whatsNext: 'Wat is de volgende stap?',
    dontShowAgain: 'Deze pop-up niet meer weergeven',
    needHelp: 'Hulp nodig?',
    userManual: 'Gebruikershandleiding',
    chooseFormat: 'Kies je voorkeursformaat',
    pdfManual: 'PDF-handleiding',
    downloadPdf: 'Downloaden en offline lezen',
    videoTutorial: 'Videotutorial',
    watchStepByStep: 'Bekijk de stapsgewijze handleiding',
    firstStepTitle: 'Welkom! We begeleiden je bij je eerste stappen.',
    activationKey: {
      title: 'Nieuwe activatiesleutels zijn succesvol geregistreerd.',
      description:
        'Stuur de activatiesleutels naar de boeren/gegevensverzamelaars zodat zij zich kunnen registreren onder jouw organisatie.',
      nextStep: 'Klik op de actieknop om het formaat te selecteren waarin je de sleutels wilt delen.',
    },
    dashboard: {
      userManagement: 'Gebruikersbeheer',
      userManagementDescription: 'De sectie Gebruikersbeheer stelt je in staat om:',
      listUser: 'De huidige lijst van mobiele en admin-gebruikers te bekijken',
      addUser: 'Nieuwe gebruikers toevoegen of gebruikers uitnodigen met activatiesleutels',
      managePermission: 'Machtigingen, lidmaatschapsplannen en rollen beheren',
      farmManagement: 'Boerderijbeheer',
      farmManagementDescription: 'Ga naar de sectie Boerderijbeheer om:',
      listFarm: 'De lijst van geregistreerde boerderijen en boeren te bekijken',
      addFarm: 'Nieuwe boerderijen één voor één of in bulk toevoegen',
      title: 'Dashboard',
      description:
        'Naarmate je meer gebruikers en boerderijen toevoegt, kun je het overzicht op het hoofddashboard zien.',
    },
    ddsDashboard: {
      title: 'Begin met de sectie “Nieuw due diligence-rapport maken” om te starten.',
      alreadyHaveFarm: 'Heb je al boerderijgegevens?',
      description:
        'Je krijgt de mogelijkheid om je boerderijgegevens toe te voegen tijdens de tweede stap van het proces "Nieuw due diligence-rapport maken".',
      createNewReport: 'Nieuw rapport maken',
      creatingReport: 'Een due diligence-rapport maken',
      sharingWithOperator: 'Delen met de operator',
      riskMitigation: 'Risicobeperking',
    },
    productionPlace: {
      title: 'Upload je boerderijgegevens',
      description: 'Upload je boerderijgegevens één voor één of in bulk door op de knop "Nieuw toevoegen" te klikken.',
      allowedFormat: 'Momenteel accepteren we de volgende formaten voor het uploaden van bulkgegevens:',
    },
    reportDetail: {
      title: 'Vul eerst de details met betrekking tot je rapport in.',
      description: 'Hulp nodig? Bekijk onze gebruikershandleidingen (PDF of video) door hier te klikken:',
      nextStep:
        'Zodra je klaar bent, klik je op "Volgende" om door te gaan naar de stap waarin je je productiegegevens van de boerderij kunt uploaden.',
    },
    adminRegistered: {
      title: 'De nieuwe admin-gebruiker is succesvol geregistreerd.',
      description:
        'Stuur de activatiesleutels naar de boeren/gegevensverzamelaars zodat zij zich kunnen registreren onder jouw organisatie.',
      nextStep: 'Wat is de volgende stap? Begin met het onboarden van boeren en gegevensverzamelaars.',
    },
  },
};
